<template>
<div>
  <div v-for="r in respondents" :key="r.userId" :class="'survey-person ' + r.role.toLowerCase()">
    
    <div class="company">
      <img v-if="r.organizationLogo" :src="r.organizationLogo" class="logo img-fluid" alt="Respondent Organiztion Logo" />
    </div>
    <div class="person">
      <p class="name">{{r.name}}</p><p class="job-title">{{r.jobTitle}}</p>
    </div>
    <div class="button-wrapper" v-if="r.responseData.responded === false && allowReminding">
      <b-button 
        variant="secondary" 
        class="remind"
        @click="sendReminder(r)"
        :disabled="r.sent || r.isLoading">
        Remind
      </b-button>
    </div>
  </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    projectName: { type: String, default: '' },
    respondents: { type: Array, default: () => [] },
    allowReminding: { type: Boolean, default: true }
  },
  data() {
    return {
      errors: []
    }
  },
  methods: {
    sendReminder(respondent) {
      respondent.isLoading = true;

      axios
        .post(`${this.$api_url}/notification/send?remind=true`,
          {
            userId: respondent.userId,
            projectName: this.projectName,
            responseId: respondent.responseData.responseId
          },
          this.getReqConfig()
        )
        .then(() => {
          respondent.responseData.lastNotifiedDate = "Today";
        })
        .catch(err => {
          this.errors.push(err);
        })
        .finally(() =>{
          respondent.isLoading = false;
          respondent.sent = true;
        });
    }
  }
}
</script>